import { render, staticRenderFns } from "./FaceCollect.vue?vue&type=template&id=7b196510&scoped=true"
import script from "./FaceCollect.vue?vue&type=script&lang=js"
export * from "./FaceCollect.vue?vue&type=script&lang=js"
import style0 from "./FaceCollect.vue?vue&type=style&index=0&id=7b196510&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b196510",
  null
  
)

export default component.exports